import { findLastIndex } from "lodash";

// Back passes over these: they redo work on mount, spend a code or attempt, or only report an outcome.
const STEPS_BACK_SKIPS = [
  "interstitial",
  "sendMfa",
  "enterMfa",
  "enter-otp",
  "validate-policy",
  "success",
  "no-policies",
  "redirect-login",
  "exit-confirmation",
  "exit-survey",
  "exit",
  "failed",
  "declaration-page-sample",
  "id-card-sample",
  "carrier-error",
  "mfa-options-error",
  "manual-document-error",
  "connection-error",
  "axle-error",
  "unsupported-document",
  "document-missing-fields",
  "document-type-not-supported",
  "text-validation-failed",
  "backup-document-required",
  "carrier-maintenance",
  "aaa-chapter-error",
  "account-pending",
  "policy-pending",
  "policy-not-active",
  "mfa-enrollment-required",
  "session-expired",
  "max-login-attempts",
  "max-server-login-attempts",
  "max-link-attempts",
];

// Back is unavailable on these: what came before is spent or the session can't continue.
const STEPS_WITHOUT_BACK = [
  "interstitial",
  "consent",
  "axle-account-sign-up",
  "enterMfa",
  "confirm",
  "validate-policy",
  "success",
  "unsupported-carrier",
  // "Try again" already routes these per integration (V123 -> carriers, MFA -> login).
  "carrier-error",
  "mfa-options-error",
  "backup-document-required",
  "session-expired",
  "max-server-login-attempts",
  "max-link-attempts",
  "connection-error",
  "axle-error",
  "failed",
  "exit",
];

/** Index in `history` that Back returns to, or -1 when Back is unavailable. */
export const findBackIndex = (history: string[], step: string) => {
  if (STEPS_WITHOUT_BACK.includes(step)) {
    return -1;
  }
  // Recovery support must return to the max-attempts page that opened it.
  if (
    step === "login-support" &&
    history[history.length - 1] === "max-login-attempts"
  ) {
    return history.length - 1;
  }
  // After a recovery link sends the user to login, Back skips support too and
  // lands on whatever came before login (usually carrier selection).
  const skips =
    step === "login"
      ? [...STEPS_BACK_SKIPS, "login-support"]
      : STEPS_BACK_SKIPS;
  return findLastIndex(
    history,
    (entry) => entry !== step && !skips.includes(entry)
  );
};
